import './day-time-calender.scss';
import React, { useState, useEffect } from 'react';
import { Field } from 'react-final-form';
import TimeSlots from '../HTO/containers/HTOScheduleLater/TImeSlots';


const Radio = ({ input, children, disabled, className, click }) => {
    return (
        <label className={`fs12 padding-5 select-time ${className}`} onClick={() => !disabled && click && click()}><input className="hto-radio-btn mr-t0" type="radio" {...input} disabled={disabled} /> {children}</label>
    );
};

const week = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

function DayTimeCalendar(props) {
    const [slots, setSlots] = useState([]);

    useEffect(() => {
        if (props.list) {
            // Assign available slot
            const slots = props.list.find(slot => slot.slots.length);
            setSlots(slots.slots);
        }
    }, [props.list]);

    const selectSlots = slots => {
        setSlots(slots);
        // Trigger click once user moves to diffrent date block
        document.querySelectorAll('.time-selector .time_0')[0].click();
    };
    return (
        <div className="day-time-calendar-container pd-10 pd-b20">
            <div className="date-selector-container margin-r10 mr-b10 flex-1">
                <h5 className="text-uppercase fsp14 fw500 mr-b10">Pick Your Date</h5>
                <div className="date-selector">
                    {props.list.map(item => {
                        const day = new Date(item.date).getDay();
                        return (
                            <div key={item.date} className={!(item.slots && item.slots.length) ? 'blur-text' : ''}>
                                <div className="text-center padding-10 date-name">{week[day]}</div>
                                <Field className={`date-value text-center ${props.values.date === item.date ? 'active' : ''}`} disabled={!(item.slots && item.slots.length)} name="date" type="radio" value={item.date} component={Radio} click={() => selectSlots(item.slots)}>{(Number(item.date.split('-')[2]) === new Date().getDate()) ? 'Today' : item.date.substring(8)}</Field>
                            </div>
                        );
                    })}
                </div>
                </div>
                <div className="time-selector-container flex-1">
                    <TimeSlots slots={slots} {...props} Radio={Radio} />
                </div>
            </div>
    );
}

export default DayTimeCalendar;
